import {
  BannerContainer,
  BannerOuterSegment,
  ClearBanner,
  Message,
} from "./BannerStyles";
import Icon from "../common/Icon";
import { useEffect, useState } from "react";
import Link from "next/link";
import { useCookies } from "react-cookie";
import { SEEN_SALES_ENGINEER_BANNER } from "../../reducers/models/flags";

const BANNER_DISABLED = false;

export default function Banner() {
  const [showBanner, setShowBanner] = useState(false);
  const [cookie, setCookie] = useCookies([SEEN_SALES_ENGINEER_BANNER], {});

  const hideBanner = () => {
    setCookie(SEEN_SALES_ENGINEER_BANNER, true, {
      expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
    });
    setShowBanner(false);
  };

  useEffect(() => {
    if (BANNER_DISABLED) {
      return;
    }
    if (!cookie[SEEN_SALES_ENGINEER_BANNER]) {
      setShowBanner(true);
    }
  }, [cookie]);

  if (showBanner) {
    return (
      <BannerContainer>
        <BannerOuterSegment />
        <Message>
          FlashPCB is hiring an Electrical Sales Engineer!{" "}
          <Link
            href={"https://www.linkedin.com/jobs/view/4478549776/"}
            target={"_blank"}
          >
            Learn more
          </Link>
          .
        </Message>
        <BannerOuterSegment>
          <ClearBanner>
            <Icon
              src="/icons/close.svg"
              alt="Dismiss banner"
              styleProps={{ margin: 0, cursor: "pointer" }}
              onClick={hideBanner}
            />
          </ClearBanner>
        </BannerOuterSegment>
      </BannerContainer>
    );
  } else {
    return null;
  }
}
